module.exports = __webpack_public_path__ + "bad48a4a525b9d7821877a0b8d0cbe02.svg";